import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIntegrationRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m11.854 14.475-3.32 5.945A2 2 0 1 0 10.8 22.4c0-.29-.06-.565-.17-.81l3.845-6.88c.32-.575.12-1.305-.455-1.63a4 4 0 0 1-1.9-4.445 4 4 0 0 1 7.88.85 1.2 1.2 0 0 0 2.4-.07 6.4 6.4 0 0 0-4.85-6.025 6.404 6.404 0 0 0-5.695 11.09zm5.975-4.07A2 2 0 1 0 14 9.6c0 1.015.76 1.855 1.74 1.985l3.865 6.87a1.2 1.2 0 0 0 1.635.455 4.002 4.002 0 1 1 0 6.975 1.203 1.203 0 0 0-1.635.455c-.325.575-.12 1.31.455 1.635a6.4 6.4 0 0 0 7.665-1.055c2.5-2.5 2.5-6.55 0-9.05a6.4 6.4 0 0 0-6.56-1.545zM23.2 24.4a2 2 0 1 0-1.6-3.2H14a1.2 1.2 0 0 0-1.2 1.2 4.002 4.002 0 1 1-6.105-3.41 1.2 1.2 0 0 0-1.255-2.045 6.403 6.403 0 0 0 5.12 11.605 6.41 6.41 0 0 0 4.525-4.95H21.6c.365.485.945.8 1.6.8",
		fill: "currentColor"
	})
});
export default SvgIntegrationRegularIcon;
